import { cambridgeConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function CambridgePage() {
  return <CityPageTemplate config={cambridgeConfig} />;
}